import {
  ATOMIC_UNIT_CHARACTER_LIMIT,
  ATOMIC_UNIT_LINE_BREAK_LIMIT,
  BLOCK_TYPE,
  EMBED_OR_IMAGE_CHARACTER_COUNT,
} from "config/constants/editor";

export default function calculateAtomicUnitCounts(
  editorState,
  hasPrimaryImage
) {
  const contentState = editorState.getCurrentContent();
  const baseLimits = [
    !hasPrimaryImage
      ? ATOMIC_UNIT_CHARACTER_LIMIT
      : ATOMIC_UNIT_CHARACTER_LIMIT - EMBED_OR_IMAGE_CHARACTER_COUNT,

    // Note that having a primary image does not reduce the line break limit.
    ATOMIC_UNIT_LINE_BREAK_LIMIT,
  ];

  // Prevent any further calculations if the content has no text. Otherwise,
  // the switch statement below would decrement the line break count for an
  // unstyled block with no text in it
  if (!contentState.hasText()) return baseLimits;

  const blockMap = contentState.getBlockMap();

  // A flag to track if the current block in the loop is below the "Go
  // deeper" (or "Keep reading") button. If the current block is below the
  // button, the block and all its following blocks are not included in the
  // atomic unit and thus the character and line break limits do not apply.
  let isBelowGoDeeper = false;

  return blockMap.reduce((total, block) => {
    if (isBelowGoDeeper) return total;

    const blockType = block.getType();
    const blockText = block.getText();
    let [characterCount, lineBreakCount] = total;

    switch (blockType) {
      case BLOCK_TYPE.KEEP_READING:
        isBelowGoDeeper = true;
        break;
      case BLOCK_TYPE.EMBED:
      case BLOCK_TYPE.IMAGE:
        characterCount -= EMBED_OR_IMAGE_CHARACTER_COUNT;
        lineBreakCount--;
        break;
      default:
        characterCount -= blockText.length;

        // Simply calculate the line break count from the block count
        lineBreakCount--;
        break;
    }

    return [characterCount, lineBreakCount];
  }, baseLimits);
}
